// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"9910147a","539":"f7b6cb61"}[chunkId] + ".chunk.js";
};